import { AdminHeader } from 'components/molecules';
import LeaveRequests from 'components/molecules/LeaveRequests';
import './LeaveApprovals.scss';

const LeaveApprovals = () => {
  return (
    <>
      <AdminHeader />
      <div className="dashboard-wrapper">
        {/* <AdminSidebar /> */}
        <LeaveRequests />
      </div>
    </>
  );
};

export default LeaveApprovals;
